import { useEffect, useState } from "react";
import styles from "./AllTasks.module.css";
import { useLocation } from 'react-router-dom';
import axios from "axios";

const AllTasks = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tasks, setTasks] = useState([]);
  const location = useLocation();
  const userID = location.state?.userID;

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  
  useEffect(() => {
  const fetchClientTasks = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER_URI}/api/therapist/client/${userID}/tasks`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    const  res = response.data;
    setTasks(tasks);
  }
  catch( error) {
    console.log(error.message);
  }
}
fetchClientTasks();
  }, []);

  return (
      <div className={styles['allTask-Container']}>
          <div className={styles['allTask-backArrow-Bg']}>
              <img src="https://ucarecdn.com/8c1645b5-ac4b-49d2-b2e2-f66eab1186da/leftVector.svg" alt="back"/>
          </div>
          <div className={styles['allTask-header-row']}>
              <div className={styles['allTask-pic-bg']}>
              <img src="https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg" alt="profile picture"/>
              </div>
              <div className={styles['allTask-header-data']}>
                  <div className={styles['allTask-header-row']}>
                  <div>
                  <p className={styles['allTask-data-heading']} style={{fontSize:'20px'}}>Swarangi Yeole</p>
                  <p className={styles['allTask-AgeData-heading']}>Age:<p className={styles['allTask-AgeData-details']}>18 yrs</p></p>
                  </div>
                  <div className={styles['allTask-msg-bg']}>
                      <img src="https://ucarecdn.com/83c14859-a37e-4a28-9665-f3b2e819b5be/chatIcon.svg" alt="msg" className={styles['allTask-msg-icon']}/>
                  </div>
                  </div>
                  <div className={styles['allTask-client-details']}>
                  <p className={styles['allTask-data-heading']}>Problems:<p className={styles['allTask-data-details']}>Anxiety</p></p>
                  <p className={styles['allTask-data-heading']}>Last Session Date:<p className={styles['allTask-data-details']}>08 Dec, 24</p></p>
                  <p className={styles['allTask-data-heading']}>Problem description:<p className={styles['allTask-data-details']}>Feeling anxious often, which makes it difficult to do regular things</p></p>
                  </div>
              </div>
          </div>

          <div className={styles['allTask-card']}>
              <p className={styles['allTask-headings']}>Tasks</p>
              <div className={styles['allTask-tasksCards']}>
              <div onClick={openModal} className={styles['allTask-AddTask-Card']} style={{justifyContent:'center'}}>
                  <p className={styles['allTask-AddTask-Card-data']}>Add task</p>
                  <div className={styles['allTask-AddIcon']}>
                  <img src="https://ucarecdn.com/e251034d-e350-46a0-bfef-9818a045bdee/addTask.svg" alt="add" style={{height:'25px',width:'25px'}}/>
                  </div>
              </div>
              <div className={styles['allTask-AddTask-Card']} style={{padding:'10px 5px 10px 5px'}}>
                  <div className={styles['allTask-dateBg']}>
                  <p className={styles['allTask-AddTask-Card-data']}>02 Apr 2025</p>
                  </div>
                  <p className={styles['allTask-AddTask-Card-data']}>Write a latter to yourself or others to express your feelings</p>
              </div>
              </div>
          </div>

          {isModalOpen && (
            <div className={styles['allTask-modal-overlay']} onClick={closeModal}>
              <div className={styles['allTask-modal']} onClick={e => e.stopPropagation()}>
                <p className={styles['allTask-modal-date']}>{formatDate(new Date())}</p>
          
                <div className={styles['allTask-modal-task-row']}>
                  <p className={styles['allTask-modal-task-heading']}>Task 1</p>
                  {/* <div className={styles['allTask-modal-dropdown']}>
                    <select style={{borderRight:'1px solid #394B42'}}>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                    <select>
                      <option value="Week">Week</option>
                      <option value="Day">Day</option>
                      <option value="Month">Month</option>
                    </select>
                  </div> */}
                </div>
          
                <textarea className={styles['allTask-modal-textarea']} />
          
                <button className={styles['allTask-add-more-tasks-btn']}>Add more tasks</button>
                <button className={styles['allTask-save-btn']}>Save</button>
              </div>
            </div>
          )}

      </div>
  );
};

export default AllTasks;